import {
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonListHeader,
} from "@ionic/react";
import { warningOutline } from "ionicons/icons";
import { useEffect, useState } from "react";

const AlarmsComponent = (props: any) => {
  // console.log("code: " + code);
  const [code, setCode] = useState(0);
  const [faultCode, setFaultCode] = useState(0);
  let arr = [];
  useEffect(() => {
    console.log("warningCode: " + props.code);
    console.log("faultCode: " + props.faultCode);
    setCode(0);
    setFaultCode(props.faultCode);
  });
  if (faultCode === 0) {
    arr.push("There are NO FAULTS");
  }
  if (code === 0) {
    arr.push("There are NO WARNINGS");
  }
  if (code & 1) {
    arr.push("Charge Under Temperature");
  }
  if (code & 2) {
    arr.push("Charge Low Temperature");
  }
  if (code & 4) {
    arr.push("Charge High Temperature");
  }
  if (code & 8) {
    arr.push("Charge Over Temperature");
  }
  if (code & 16) {
    arr.push("Discharge Under Temperature");
  }
  if (code & 32) {
    arr.push("Discharge Low Temperature");
  }
  if (code & 64) {
    arr.push("Discharge High Temperature");
  }
  if (code & 128) {
    arr.push("Discharge Over Temperature");
  }
  if (code & 256) {
    arr.push("Cell Under Voltage");
  }
  if (code & 512) {
    arr.push("Cell Low Voltage");
  }
  if (code & 1024) {
    arr.push("Cell High Voltage");
  }
  if (code & 2048) {
    arr.push("Cell Over Voltage");
  }
  if (code & 4096) {
    arr.push("Pack Under Voltage");
  }
  if (code & 8192) {
    arr.push("Pack Low Voltage");
  }
  if (code & 16384) {
    arr.push("Pack High Voltage");
  }
  if (code & 32768) {
    arr.push("Pack Over Voltage");
  }
  if (code & 65536) {
    arr.push("Cell High Deviation");
  }
  if (code & 131072) {
    arr.push("Cell Over Deviation");
  }
  if (code & 262144) {
    arr.push("Charge Over Current");
  }
  if (code & 524288) {
    arr.push("Charge High Current");
  }
  if (code & 1048576) {
    arr.push("Discharge High Current");
  }
  if (code & 2097152) {
    arr.push("Discharge Over Current");
  }
  if (code & 4194304) {
    arr.push("Low SOC Warning");
  }
  if (code & 8388608) {
    arr.push("Short Circuit Warning");
  }
  if (code & 16777216) {
    arr.push("Hardware Fault");
  }
  return (
    <IonGrid>
      <IonListHeader>List of Faults & Warnings</IonListHeader>
      {arr.map((item, index) => (
        <IonItem key={index}>
          <IonIcon icon={warningOutline} size="large" />
          <IonLabel className="ion-padding">
            <h2>{item}</h2>
          </IonLabel>
        </IonItem>
      ))}
    </IonGrid>
  );
};

export default AlarmsComponent;
